// Port of api/fuel/app/classes/insights/records/distribution.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'

export default Segment.extend({
	name: 'distribution',
	types: [Constants.TYPE_USER],
	requires: ['init'],
	insight: false,
	detail: false,
	run: function() {
		var plays = this._data.plays || []
		var distribution = {
			counts: {},
			weights: {}
		}

		if (!plays.length) return { distribution: distribution }

		// Pull game weights via raw SQL (was Game.where().associated() which
		// instantiated thousands of Model objects). Build a flat hash keyed
		// by game_id for O(1) lookup in the main loop.
		var gameIdSet = {}
		for (var p = 0; p < plays.length; p++) {
			var gid = parseInt(plays[p].game, 10) || 0
			if (gid) gameIdSet[gid] = true
		}
		var gameIds = Object.keys(gameIdSet).map(function(k) { return parseInt(k, 10) })

		var gameWeights = {}
		if (gameIds.length) {
			var weightRows = Util.queryFast(
				'SELECT game_id, game_weight_avg FROM game WHERE game_id IN(' + Util.in(gameIds) + ')'
			)
			for (var w = 0; w < weightRows.length; w++) {
				gameWeights[parseInt(weightRows[w].game_id, 10)] = parseFloat(weightRows[w].game_weight_avg) || 0
			}
		}

		for (var i = 0; i < plays.length; i++) {
			var play = plays[i]
			if (!play.result) continue

			if (!distribution.counts[play.players]) {
				distribution.counts[play.players] = {
					count: play.players,
					plays: 0,
					wins: 0
				}
			}

			distribution.counts[play.players].plays += parseInt(play.count, 10)
			distribution.counts[play.players].wins += parseInt(play.won, 10)

			if (gameWeights[play.game] === undefined) continue
			var weight = gameWeights[play.game]
			if (weight <= 1.49999) weight = 1
			else if (weight <= 2.49999) weight = 2
			else if (weight <= 3.49999) weight = 3
			else if (weight <= 4.49999) weight = 4
			else weight = 5

			if (!distribution.weights[weight]) {
				distribution.weights[weight] = {
					count: weight,
					plays: 0,
					wins: 0
				}
			}

			distribution.weights[weight].plays += parseInt(play.count, 10)
			distribution.weights[weight].wins += parseInt(play.won, 10)
		}

		return {
			distribution: distribution
		}
	}
})
